// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSBadge/index.less
// module id = 716
// module chunks = 42